import React from 'react';
import { Box, List, ListItem, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSetBackground } from '../../../util/hooks/useSetBackground';
import { bottomTextWrapperStyle, centerTextWrapperStyle } from './Carglass.styled';

export const Carglass: React.FC = () => {
  useSetBackground('repair');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 12, pr: 12 }}>
      <Box
        sx={{
          backgroundColor: 'custom.opaqueBackground',
          boxShadow: '2px 5px 10px black',
          borderRadius: '10px',
          p: 1,
          m: 3,
          width: 'fit-content',
          alignSelf: 'flex-end',
        }}
      >
        <Typography
          color="primary.main"
          variant="h2"
          align="center"
          sx={{ p: 4, alignItems: 'center', display: 'flex', gap: 2 }}
        >
          <FormattedMessage id="carglass.headline" />
        </Typography>
      </Box>

      <Box sx={centerTextWrapperStyle}>
        <Typography color="secondary.main">
          <FormattedMessage id="carglass.text.1" />
        </Typography>
        <Typography color="secondary.main">
          <FormattedMessage id="carglass.text.2" />
        </Typography>
        <Typography color="secondary.main">
          <FormattedMessage id="carglass.text.3" />
        </Typography>
        <List sx={{ pl: 2 }}>
          <ListItem>
            <Typography color="secondary.main">
              <FormattedMessage id="carglass.text.5.1" />
            </Typography>
          </ListItem>
          <ListItem>
            <Typography color="secondary.main">
              <FormattedMessage id="carglass.text.5.2" />
            </Typography>
          </ListItem>
          <ListItem>
            <Typography color="secondary.main">
              <FormattedMessage id="carglass.text.5.3" />
            </Typography>
          </ListItem>
        </List>
        <Typography color="secondary.main">
          <FormattedMessage id="carglass.text.5.4" />
        </Typography>
      </Box>
      <Box sx={bottomTextWrapperStyle}>
        <List>
          <ListItem>
            <Typography color="secondary.main">
              <FormattedMessage id="carglass.text.6" />
            </Typography>
          </ListItem>
          <ListItem>
            <Typography color="secondary.main">
              <FormattedMessage id="carglass.text.7" />
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};
